// @flow
import type { ComponentType } from 'react';
import React, { useEffect } from 'react';

type Props = {|
  poll: Function,
|};

type GetComponent = (ComponentType<Object>) => ComponentType<Props>;

const getComponent: GetComponent = C => (props: Props) => {
  const { poll, ...rest } = props;
  useEffect(poll, []);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <C {...rest} />
  );
};

export default getComponent;
